// OnlyOffice: ONLYOFFICE_ENABLED / ONLYOFFICE_URL from .env via
// scripts/syncOnlyOfficeEnv.js → onlyOfficeEnv.ts

import {default as data} from '../../package.json';
import { onlyOfficeEnv } from './onlyOfficeEnv';

const environment = 
{
    VERSION: data.version,
    production: true,

//    apiUrl : 'https://lafayetteapi.cyphersystem.com',
//    authUrl : 'https://lafayetteapi.cyphersystem.com',
//    courtUrl : 'https://lafayettecc.cyphersystem.com',

    apiUrl : 'https://lafayettesandboxapi.cyphersystem.com',
    authUrl : 'https://lafayettesandboxapi.cyphersystem.com',
    courtUrl : 'https://lafayettesandboxcc.cyphersystem.com',

    onlyOfficeEnabled: onlyOfficeEnv.enabled,
    onlyOfficeUrl: onlyOfficeEnv.url,

    sentryDsn:
        'https://2c0b7179e62f28ec52f8432e6d07d245@o4512148365377536' +
        '.ingest.us.sentry.io/4512148375732224',
    sentryEnvironment: 'production'
}

export { environment };
